import React, { useState } from 'react';
import { Box, Typography,Tabs,Tab } from '@mui/material';
import BookingForm from '../components/BookingForm';
import AvailabilityCalendar from '../components/AvailabilityCalendar';  

// Logo color palette
const logoColors = {
    primaryBlue: '#3f51b5',
    brightYellow: '#c4d835',
    darkBlue: '#2c387e',
    lightYellow: '#d4e157',
};

const BookingPage = () => {
    const [tabValue, setTabValue] = useState(0);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleBookingCreated = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box>
            {/* <Typography variant="h4" component="h1" gutterBottom color="primary" sx={{ textAlign: 'center', mb: 4 }}>
                Book Your Futsal Court
            </Typography> */}

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    centered
                    textColor="inherit"
                    TabIndicatorProps={{ style: { backgroundColor: logoColors.darkBlue } }}
                    sx={{
                        color: logoColors.brightYellow,
                        '& .MuiTab-root': { color: logoColors.brightYellow },
                        '& .Mui-selected': { color: logoColors.brightYellow }
                    }}
                >
                    <Tab label="New Booking" />
                    {/* <Tab label="Availability" />     */}
                </Tabs>
            </Box>
            
            {tabValue === 0 && <BookingForm onBookingCreated={handleBookingCreated} />}
            {/* {tabValue === 1 && <AvailabilityCalendar key={refreshTrigger} />} */}
        </Box>
    );
};

export default BookingPage;